import React from "react";
import { cn } from "@/lib/utils";

interface LogoProps extends React.SVGProps<SVGSVGElement> {
  variant?: "light" | "dark";
}

export const Logo = ({ className, variant = "dark", ...props }: LogoProps) => {
  // Use variant to determine text color (white when transparent, navy when scrolled)
  const textColor = variant === "light" ? "#FFFFFF" : "hsl(217 33% 17%)";
  const goldColor = "hsl(45 60% 53%)";

  return (
    <svg
      viewBox="0 0 460 120"
      className={cn("h-16 w-auto", className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <image
        href="https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a3b4f77967e20d627d34fd3.webp"
        x="5"
        y="10"
        width="100"
        height="100"
      />

      <text
        x="120"
        y="78"
        fontFamily="'IBM Plex Sans', sans-serif"
        fontWeight="bold"
        fontSize="76"
        letterSpacing="-0.01em"
        fill={textColor}
        style={{
          filter:
            variant === "light"
              ? "drop-shadow(0px 2px 8px rgba(0,0,0,0.8))"
              : "none",
        }}
      >
        Pinheiro
      </text>

      <text
        x="120"
        y="102"
        fontFamily="'IBM Plex Sans', sans-serif"
        fontWeight="400"
        fontSize="17.5"
        letterSpacing="0.06em"
        fill={goldColor}
        style={{
          filter:
            variant === "light"
              ? "drop-shadow(0px 2px 8px rgba(0,0,0,0.8))"
              : "none",
        }}
      >
        Advocacia para servidores públicos
      </text>
    </svg>
  );
};
